<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/"
          :class="!getRoute() ? 'active' : ''"
          :navText="'Domů'"
        >
          <template v-slot:icon>
            <i class="fa-solid fa-house text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/otevrene-hry"
          :class="getRoute() === '/otevrene-hry' || getRoute() === 'otevrene-hry' ? 'active' : ''"
          :navText="'Otevřené hry'"
        >
          <template v-slot:icon>
            <!-- Použijeme otevřenou složku / registraci -->
            <i class="fa-solid fa-folder-open text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/aktualni-hry"
          :class="getRoute() === '/aktualni-hry' ? 'active' : ''"
          :navText="'Aktuální hry'"
        >
          <template v-slot:icon>
            <!-- Použijeme zelené tlačítko Play pro běžící hru -->
            <i class="fa-solid fa-play text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/akcie"
          :class="getRoute() === '/akcie' ? 'active' : ''"
          :navText="'Akcie ČR'"
        >
          <template v-slot:icon>
            <!-- Ponecháme skvělý graf, ale změníme barvu na Info (tyrkysová) -->
            <i class="fa-solid fa-chart-line text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/ukoncene-hry"
          :class="getRoute() === 'ukoncene-hry' ? 'active' : ''"
          :navText="'Ukončené hry'"
        >
          <template v-slot:icon>
            <i class="fa-solid fa-flag-checkered text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/top-20"
          :class="getRoute() === 'top-20' ? 'active' : ''"
          :navText="'Top 20'"
        >
          <template v-slot:icon>
            <i class="fa-solid fa-trophy text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li v-if="isLoggedIn" class="nav-item" >
        <sidenav-item
          url="/moje-inga"
          :class="getRoute() === '/moje-inga' ? 'active' : ''"
          :navText="'Moje INGA'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li v-if="isLoggedIn" class="nav-item" >
        <sidenav-item
          url="/profil"
          :class="getRoute() === 'profil' ? 'active' : ''"
          :navText="getUser?.UserNickName"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li v-if="isLoggedIn" class="nav-item" >
        <sidenav-item
          @click.prevent="openModal({ 
            title: 'Uplatnění voucheru', 
            view: 'AddVoucher' 
          })"
          :navText="'Voucher'"
        >
          <template v-slot:icon>
            <fa-icon class="text-primary" icon="fa-solid fa-ticket" />
          </template>
        </sidenav-item>
      </li>
      <li v-if="isLoggedIn" class="nav-item" >
        <sidenav-item
          @click.prevent="logout"
          :navText="'Odhlásit se'"
        >
          <template v-slot:icon>
            <!-- Moderní šipka ven z obdélníku (Odhlášení) v červené barvě -->
            <i class="fa-solid fa-right-from-bracket text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li v-if="!isLoggedIn" class="nav-item" >
        <sidenav-item
          @click.prevent="toggleLoginForm"
          :navText="'Přihlásit'"
        >
          <template v-slot:icon>
            <!-- Šipka směřující dovnitř (Login) -->
            <i class="fa-solid fa-right-to-bracket text-primary text-sm"></i>
          </template>
        </sidenav-item>
      </li>
      <li v-if="!isLoggedIn" class="nav-item" >
        <sidenav-item
          @click.prevent="toggleRegisterForm"
          :navText="'Registrovat'"
        >
          <template v-slot:icon>
            <!-- Uživatel s pluskem (Registrace) -->
            <i class="fa-solid fa-user-plus text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item sidenav-section-label">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="'ms-2'"
          :style="$store.state.isDarkMode ? 'color: #94A3B8 !important; opacity: 1;' : ''"
        >
          Informace
        </h6>
      </li>
      <li v-if="isLoggedIn && isAnimator" class="nav-item">
        <sidenav-item
          url="/animator"
          :class="getRoute() === 'animator' ? 'active' : ''"
          :navText="'Animátor'"
        >
          <template v-slot:icon>
            <i class="fa-solid fa-wand-magic-sparkles text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/forum"
          :class="getRoute() === 'forum' ? 'active' : ''"
          :navText="'Fórum'"
        >
          <template v-slot:icon>
            <i class="fa-regular fa-comment-dots text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/jak-hrat"
          :class="getRoute() === 'how-to-play' ? 'active' : ''"
          :navText="'Jak hrát'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/strategie"
          :class="getRoute() === 'strategie' ? 'active' : ''"
          :navText="'Strategie'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/slovnik"
          :navText="'Slovník pojmů'"
        >
          <template v-slot:icon>
            <i class="fa-solid fa-book"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/faq"
          :class="getRoute() === 'FAQ' ? 'active' : ''"
          :navText="'FAQ'"
        >
          <template v-slot:icon>
            <fa-icon class="text-info opacity-10" icon="fa-solid fa-circle-info" />
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/media"
          :class="getRoute() === 'media' ? 'active' : ''"
          :navText="'Média'"
        >
          <template v-slot:icon>
            <i class="fa-solid fa-circle-play text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          @click.prevent="toggleHelpDeskDialog"
          :navText="'Helpdesk'"
        >
          <template v-slot:icon>
            <fa-icon class="text-primary opacity-10" icon="fa-solid fa-phone"  />
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/about"
          :class="getRoute() === 'about' ? 'active' : ''"
          :navText="'O mně'"
        >
          <template v-slot:icon>
            <fa-icon class="text-info opacity-10" icon="fa-solid fa-address-card" />
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "SidenavList",
  components: {
    SidenavItem,
  },
  props: {
    cardBg: String
  },
  computed: {
    ...mapGetters([
      'isLoggedIn',
      'getUser',
      'isAnimator'
    ])
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: false
    };
  },
  methods: {
    ...mapActions(['toggleHelpDeskDialog', 'openModal']),
    ...mapMutations([
      'toggleLoginForm',
      'toggleRegisterForm'
    ]),
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    logout() {
        this.$store.dispatch('logout');
    }
  }
};
</script>
